import { Controller } from "@hotwired/stimulus"

// Restore both axes when returning from a workflow detail page.
export default class extends Controller {
  static values = {
    key: String,
  }

  connect() {
    this.storageKey = `paperwork:board-scroll:${this.keyValue || window.location.pathname}`
    this.restore()
  }

  preserve(event) {
    if (event && !event.target.closest(".kanban-card a, nav")) return
    this.save()
  }

  save() {
    sessionStorage.setItem(this.storageKey, JSON.stringify({
      left: this.element.scrollLeft,
      url: window.location.pathname + window.location.search,
      columns: Object.fromEntries(Array.from(this.element.querySelectorAll("turbo-frame[data-board-column-key]"), frame => [frame.id, frame.scrollTop])),
      savedAt: Date.now(),
    }))
  }

  restore() {
    const rawPosition = sessionStorage.getItem(this.storageKey)
    if (!rawPosition) return

    try {
      const position = JSON.parse(rawPosition)
      if (Date.now() - position.savedAt > 5 * 60 * 1000) {
        sessionStorage.removeItem(this.storageKey)
        return
      }

      if (position.url && position.url !== window.location.pathname + window.location.search) return
      this.pendingColumns = position.columns || {}
      requestAnimationFrame(() => {
        this.element.scrollLeft = position.left
        this.element.querySelectorAll("turbo-frame[data-board-column-key]").forEach(frame => this.restoreColumn({ target: frame }))
        sessionStorage.removeItem(this.storageKey)
      })
    } catch (_error) {
      sessionStorage.removeItem(this.storageKey)
    }
  }
  restoreColumn(event) {
    const frame = event.target
    const top = this.pendingColumns?.[frame.id]
    if (top == null || !frame.querySelector('[data-board-page]')) return
    frame.scrollTop = top
    delete this.pendingColumns[frame.id]
  }

}
